import React from "react";
import { default as MUIChip } from "@mui/material/Chip";
import styled from "styled-components";

const StyledMUIChip = styled(MUIChip)``;

export const Chip = (props) => {
  return <StyledMUIChip {...props} />;
};
